import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../mixins';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.core_white};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
  padding-top: 2.5rem;
  padding-bottom: 5rem;

  ${mq.small(css`
    padding-bottom: 4rem;
  `)};

  ${mq.xLarge(css`
    padding-top: 5rem;
    padding-bottom: 8.75rem;
  `)};
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  line-height: 3.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  margin: 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.75rem;
  `)};

  ${mq.xLarge(css`
    font-size: 4rem;
    line-height: 5rem;
  `)};
`;

export const Subtitle = styled.h2`
  margin: 3rem 0 0.75rem 0;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 400;

  &:first-child {
    margin-top: 0;
  }
`;

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.black};
  margin: 0.75rem 0;
  font-family: ${({ theme }) => theme.font.nunito};
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const OrderedList = styled.ol`
  color: ${({ theme }) => theme.colors.black};
  margin: 0.75rem 0;
  padding-left: 1.5rem;
  font-family: ${({ theme }) => theme.font.nunito};
  font-size: 1rem;
  line-height: 1.5rem;
  counter-reset: custom-counter;
  list-style: none outside none;
  position: relative;
`;

export const OrderedListItem = styled.li`
  color: ${({ theme }) => theme.colors.black};
  margin: 0.75rem 0;
  font-family: var(--font-second);
  font-size: 1rem;
  line-height: 1.5rem;
  counter-increment: custom-counter;

  &:before {
    content: counter(custom-counter) ') ';
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
`;

export const LastUpdate = styled.p`
  font-size: 1rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.dark_grey};
  margin: 0 0 0.5rem;
`;

export const Content = styled.div`
  padding-top: 1.5rem;

  ${mq.medium(css`
    margin-left: 3rem;
  `)};

  ${mq.xLarge(css`
    padding-top: 2.5rem;
    margin-left: 6.25rem;
  `)};
`;
